/*
 *  -----------------------------------------------------------------------
 *    <copyright file="review-history-grid.data.ts" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import { GridColumnDateFilterV2 } from '@components/core/grid-filters-v2';
import { useGridCells } from '@hooks/index';

const { NumberCell, DateCell, MaxLengthCell } = useGridCells();

export const REVIEW_HISTORY_GRID_COLUMNS = (translate: (word: string) => string) => [
    {
        label: translate('id'),
        field: 'recordId',
        minWidth: 120,
        id: 'review-history-id',
        filter: 'numeric',
        cells: { data: NumberCell },
        showByDefault: false,
    },
    {
        label: translate('cm:datasetDate'),
        id: 'review-dataset-date',
        minWidth: 130,
        field: 'dataCutDate',
        lockedByDefault: true,
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        field: 'reviewer',
        id: 'review-reviewer',
        label: translate('cm:reviewer'),
        minWidth: 120,
        cells: { data: MaxLengthCell(100) },
    },
    {
        field: 'summary',
        id: 'review-summary',
        label: translate('cm:summary'),
        minWidth: 200,
        cells: { data: MaxLengthCell(150) },
    },
    {
        field: 'startDate',
        id: 'review-start-date',
        label: translate('cm:reviewStartDate'),
        minWidth: 160,
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        field: 'completedDate',
        id: 'review-completed-date',
        label: translate('cm:reviewCompleteDate'),
        minWidth: 190,
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
    {
        field: '_updatedByString',
        id: 'review-updated-by',
        label: translate('ra:updatedBy'),
        minWidth: 130,
    },
    {
        field: 'updated',
        id: 'review-updated-date',
        label: translate('ra:updatedDate'),
        minWidth: 150,
        cells: { data: DateCell },
        filter: 'date',
        filterUi: GridColumnDateFilterV2,
    },
];
